import { ref, readonly, h, defineComponent } from "vue";
import BasicDialogComponent from '@/components/dialogs/BasicDialog.vue';

// �X�e�[�g
const modal = ref({
    title: "", // TITLE
    message: "", // ���b�Z�[�W
    isConfilm: false, // �m�F���邩�H
});

// �_�C�A���O�I�[�v������t���O
const isOpen = ref(false);

// �߂�l
const _resolve = ref<(ans: boolean) => void>(() => { })

/**
 * BasicDialog
 */
export default function useBasicDialog() {

    /**
     * �_�C�A���O���J���F�{�^���������ꂽ�^�C�~���O�ŁA���ʂ�Ԃ�
     * @return Promise<bool>
     */
    const openDialog = async (title: string, message: string) => {

        // ��Ԃ̃Z�b�g
        modal.value.title = title;
        modal.value.message = message;
        modal.value.isConfilm = false;

        // �_�C�A���O�I�[�v��
        isOpen.value = true;

        return new Promise<boolean>((resolve) => {
            _resolve.value = resolve
        })
    };

    /**
     * �m�F�_�C�A���O���J���F�{�^���������ꂽ�^�C�~���O�ŁA���ʂ�Ԃ�
     * @return Promise<bool>
     */
    const openConfilmDialog = async (title: string, message: string) => {
        // ��Ԃ̃Z�b�g
        modal.value.title = title;
        modal.value.message = message;
        modal.value.isConfilm = true;

        // �_�C�A���O�I�[�v��
        isOpen.value = true;

        return new Promise<boolean>((resolve) => {
            _resolve.value = resolve
        })
    };

    /**
     * �_�C�A���O�����
     */
    const closeDialog = (result: boolean) => {
        // ���ʂ�ԋp
        _resolve.value(result);

        // �X�e�[�g���Z�b�g
        modal.value.title = "";
        modal.value.message = "";
        isOpen.value = false;

        // ���[�_�������
        _resolve.value = () => { }
    };

    // �_�C�A���O�R���|�[�l���g�̕`��
    const render = () => h(BasicDialogComponent);
    const BasicDialog = defineComponent({ render });

    return {
        // data
        isOpen: readonly(isOpen),
        state: readonly(modal),

        // methods
        openDialog,
        openConfilmDialog,
        closeDialog,

        // components
        BasicDialog
    };
}